import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={6}>
            <h2>
              Comprehensive <span>Web Application Development</span> Services
              for Diverse Business Needs
            </h2>
            <p>
              Being a renowned website application development company, we
              provide a complete package of services for web development. Our
              experienced professionals understand your specific business
              requirements and offer you the best web application development
              solution that will definitely impress you!
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-xxl-0"
          >
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Custom Web Application Development</h4>
                  <p>
                    As a leading custom web application development firm, we
                    provide bespoke solutions that complement your
                    organizational goals and visions. Whether your requirement
                    is for an efficient back-end interface or a comprehensive
                    front-end solution, our experienced developers build web
                    apps that deliver exceptional functionality.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Open Source Web Development and Reva</h4>
                  <p>
                    We offer web development services that make use of open
                    source development to improve development and reduce
                    expenses. They include elegant and reliable frameworks and
                    libraries, which we use to create reliable web sites and web
                    applications at a fast pace.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Progressive Web Apps Development</h4>
                  <p>
                    Discover the potential of Progressive Web Apps and take
                    advantage of our leading-edge PWA development solutions. We
                    build feature-rich, lightning-fast web applications that
                    integrate with the device, and support offline, and push
                    notifications. Maintaining a high-value UI/UX, we ensure the
                    optimal performance of PWAs across different browsers.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Ongoing Support and Maintenance</h4>
                  <p>
                    The commitment here does not end at launch but its
                    implementation is ongoing. Being the top web app development
                    company we offer full support and maintenance services to
                    guarantee your app stays protected and updated considering
                    the everyday changes and new threats in this field.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
